import { useState } from "react";
import { connect } from "react-redux";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import toast from "react-hot-toast";

import CustomInput from "../../../common/CustomInputV2";
import CustomLoader from "../../../common/CustomLoader";
import CustomActionButton from "../../../common/CustomActionButton";

import { apiCallV2 } from "../../../utils/api";
import { SetMyProfile } from "../../../redux/profile/actions";
import { validations } from "../../../constants";

import "./style.css";

const Login = (props) => {
    const [searchParams, setSearchParams] = useSearchParams();

    window?.callIdentify?.();

    const offer = searchParams.get("offer");

    const navigate = useNavigate();
    const [userName, setUserName] = useState("");
    const [password, setPassword] = useState("");
    const [error, setErrorMessage] = useState("");
    const [passwordError, setpasswordError] = useState("");
    const [loading, setLoading] = useState(false);
    const [isVisible, setIsVisible] = useState(false);

    const onChangeUserName = (event) => {
        setUserName(event.target.value);
        if (userName == "") {
            setErrorMessage("");
        }
        if (error != "" && validations.usernameRegex.test(userName)) {
            setErrorMessage("");
        }
    };

    const onChangePassword = (event) => {
        setPassword(event.target.value);
        if (password === "") {
            setpasswordError("");
        }
    };

    const onClickLogin = async () => {
        if (userName.trim() === "") {
            setErrorMessage("");
        } else if (userName.trim().length < 2) {
            setErrorMessage(validations.userNameLengthValidation);
        } else if (password === "") {
            setpasswordError(validations.passwordValidation);
        } else {
            setErrorMessage("");
            setpasswordError("");
            const res = await apiCallV2("POST", "admin/login", {
                user_name: userName,
                password: password,
                user_type: 2, //1 is customer,0 is admin
            });

            if (res.status && res.data.status === 200) {
                const profile = res?.data?.data;
                props.SetMyProfile(profile);

                localStorage.setItem("access-token", res.data.data.access_token);

                localStorage.setItem("admin-info", JSON.stringify(res.data.data));

                if (profile?.role == 4) {
                    navigate("/users");
                } else {
                    navigate("/");
                }
            } else {
                toast.error(res.data.message);
            }
        }
    };

    return (
        <div id="login-area" className="auth-box">
            <div className="container">
                <Link to={"/home"}>
                    <img src="/assets/images/logo.png" alt="Indi" height={"40px"} />
                </Link>
                <div className="auth-form login-form">
                    <h1 className="title-txt text-md-left">Log In</h1>
                    <form>
                        <div className="form-group">
                            <div className="d-flex align-items-center">
                                {/* <label>Username</label> */}
                                <CustomInput
                                    placeholder="USERNAME OR EMAIL"
                                    style={{
                                        borderColor: error == "" ? "lightgrey" : "red",
                                    }}
                                    type="text"
                                    value={userName}
                                    name="userName"
                                    onChange={(event) => onChangeUserName(event)}
                                    className="i-box"
                                />
                            </div>
                            {error != "" && <p className="error">{error}</p>}
                        </div>
                        <div className="form-group">
                            <div className="d-flex align-items-center">
                                {/* <label>Password</label> */}
                                <div className="position-relative i-box">
                                    <CustomInput
                                        placeholder="PASSWORD"
                                        autoComplete="new-password"
                                        style={{
                                            borderColor: passwordError == "" ? "lightgrey" : "red",
                                        }}
                                        value={password}
                                        name="password"
                                        onChange={(event) => onChangePassword(event)}
                                        // className="i-box"
                                        type={isVisible ? "text" : "password"}
                                    />
                                    <button onClick={() => setIsVisible(!isVisible)} type="button" className="btn btn-light icon-right">
                                        <img src={`/assets/images/${isVisible ? "eye-off" : "eye"}.svg`} alt="Eye" />
                                    </button>
                                </div>
                            </div>
                            {passwordError != "" && <p className="error">{passwordError}</p>}
                        </div>
                        <div className="text-center" style={{ padding: "20px 0" }}>
                            <CustomActionButton action={onClickLogin} type={2}>
                                Log in
                            </CustomActionButton>
                        </div>

                        <p className="e-text reset-link">
                            <Link to={"/reset-password"}>Reset Password</Link>.
                        </p>
                    </form>
                </div>
            </div>
            {loading && <CustomLoader loading={loading} />}
        </div>
    );
};

const mapStateToProps = (state) => ({});

export default connect(mapStateToProps, {
    SetMyProfile,
})(Login);
